module.exports = __webpack_public_path__ + "img/havells.70824c3e.png";